export const operationSections = [
  ['operation-summary', 'Visão geral'],
  ['operation-planning', 'Planejamento e horários'],
  ['operation-resources', 'Pessoas e serviços'],
  ['operation-pending', 'Pendências e checklist'],
  ['coordination-decision', 'Coordenação'],
  ['operational-decision', 'Decisão operacional'],
  ['operation-execution', 'Execução'],
  ['operation-occurrences', 'Ocorrências'],
  ['operation-closure', 'Encerramento'],
  ['operation-report', 'Relatório'],
] as const;
export function focusOperationalSection(id: string) {
  const target = document.getElementById(id);
  if (!target) return;
  target.tabIndex = -1;
  target.focus({ preventScroll: true });
  target.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    block: 'start',
  });
}
export function OperationalNavigation({
  canCreate,
  canViewAgenda = false,
  hasOperation,
  onNavigate,
}: {
  readonly canCreate: boolean;
  readonly canViewAgenda?: boolean;
  readonly hasOperation: boolean;
  readonly onNavigate: (section: string) => void;
}) {
  const items: readonly (readonly [string, string, string])[] = [
    ...(canViewAgenda ? [['operation-agenda', 'Agenda de voos', '▦'] as const] : []),
    ['shift-handoff', 'Passagem de turno', '⇄'],
    ...(canCreate ? [['operation-composer', 'Nova operação', '+'] as const] : []),
    ...(hasOperation ? [['operation-summary', 'Retomar operação', '↗'] as const] : []),
  ];
  return (
    <div className="operationalNavigation">
      {items.map(([id, label, icon]) => (
        <button
          key={id}
          type="button"
          onClick={(event) => {
            event.currentTarget.closest('details')?.removeAttribute('open');
            onNavigate(id);
          }}
        >
          <span className="navActionIcon" aria-hidden="true">
            {icon}
          </span>
          {label}
        </button>
      ))}
    </div>
  );
}

export function MobileOperationalNavigation({
  canCreate,
  canViewAgenda,
  onNavigate,
}: {
  readonly canCreate: boolean;
  readonly canViewAgenda: boolean;
  readonly onNavigate: (section: string) => void;
}) {
  const items: readonly (readonly [string, string, string])[] = [
    ...(canViewAgenda ? [['operation-agenda', 'Agenda', '▦'] as const] : []),
    ['operations-list', 'Voos', '✈'],
    ...(canCreate ? [['operation-composer', 'Lançar voo', '+'] as const] : []),
    ['shift-handoff', 'Turno', '⇄'],
  ];

  return items.map(([section, label, icon]) => (
    <button key={section} type="button" onClick={() => onNavigate(section)}>
      <span className="mobileNavIcon" aria-hidden="true">
        {icon}
      </span>
      <span>{label}</span>
    </button>
  ));
}
